import tripoolSwapABI from './json/3pool/swap';
import Plain2Basic from './json/factory-v2/Plain2Basic';
import Plain2BasicEMA from './json/factory-v2/Plain2BasicEMA';
import Plain2Balances from './json/factory-v2/Plain2Balances';
import Plain2ETH from './json/factory-v2/Plain2ETH';
import Plain2ETHEMA from './json/factory-v2/Plain2ETHEMA';
import Plain2Optimized from './json/factory-v2/Plain2Optimized';
import Plain3Basic from './json/factory-v2/Plain3Basic';
import Plain3Balances from './json/factory-v2/Plain3Balances';
import Plain3ETH from './json/factory-v2/Plain3ETH';
import Plain3Optimized from './json/factory-v2/Plain3Optimized';
import Plain4Basic from './json/factory-v2/Plain4Basic';
import Plain4Balances from './json/factory-v2/Plain4Balances';
import Plain4ETH from './json/factory-v2/Plain4ETH';
import Plain4Optimized from './json/factory-v2/Plain4Optimized';
import DepositZapFantom from './json/factory-v2/DepositZapFantom';

const multicall_address = '0x30A62aA52Fa099C4B227869EB6aeaDEda054d121';

const poolsData = {
    'factory-v2-0': {
        swap_abi: tripoolSwapABI,
        N_COINS: 3,
        coin_precisions: [1e18, 1e6, 1e6],
        wrapped_precisions: [1e18, 1e6, 1e6],
        tethered: [false, false, false],
        use_lending: [false, false, false],
        is_plain: [true, true, true],
        swap_address: '0x7A0e3b70b1dB0D6CA63Cac240895b2D21444A7b9',
        token_address: '0x7A0e3b70b1dB0D6CA63Cac240895b2D21444A7b9',
        gauge_address: '0x7A0e3b70b1dB0D6CA63Cac240895b2D21444A7b9',
        underlying_coins: [
            '0x765277EebeCA2e31912C9946eAe1021199B39C61',
            '0xfA9343C3897324496A05fC75abeD6bAC29f8A40f',
            '0xB44a9B6905aF7c801311e8F4E76932ee959c663C',
        ],
        coins: [
            '0x765277EebeCA2e31912C9946eAe1021199B39C61',
            '0xfA9343C3897324496A05fC75abeD6bAC29f8A40f',
            '0xB44a9B6905aF7c801311e8F4E76932ee959c663C',
        ],
        is_factory: true,
    }
};

const factoryPoolDataSkeleton = {
    swap_abi: tripoolSwapABI,
    N_COINS: 3, // to fill and replace w/ null in skeleton
    coin_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    tethered: [false, false], // to fill and replace w/ null in skeleton
    use_lending: [false, false], // to fill and replace w/ null in skeleton
    is_plain: [true, true], // to fill and replace w/ null in skeleton
    swap_address: '0xace58a26b8db90498ef0330fdc9c2655db0c45e2', // to fill and replace w/ null in skeleton
    token_address: '0xace58a26b8db90498ef0330fdc9c2655db0c45e2', // to fill and replace w/ null in skeleton
    gauge_address: '0xace58a26b8db90498ef0330fdc9c2655db0c45e2', // Fake pool address to prevent old multicalls from reverting
    underlying_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
    ],
    deposit_abi: DepositZapFantom,
    deposit_address: '0xA79828DF1850E8a3A3064576f380D90aECDD3359',
    is_meta: true,
    base_pool: '3pool', // to fill and replace w/ null in skeleton
    meta_N: 5, // to fill and replace w/ null in skeleton
    meta_precisions: [1e18, 1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_coin_precisions: [1e18, 1e18, 1e6, 1e6], // to fill and replace w/ null in skeleton
    meta_wrapped_precisions: [1e18, 1e18], // to fill and replace w/ null in skeleton
    meta_coins: [ // to fill and replace w/ null in skeleton
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    all_coins: [ // to fill and replace w/ null in skeleton
        '0x5f98805A4E8be255a32880FDeC7F6728C6568bA0',
        '0x6c3F90f043a72FA612cbac8115EE7e52BDe6E490',
        '0x6B175474E89094C44Da98b954EedeAC495271d0F',
        '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48',
        '0xdAC17F958D2ee523a2206206994597C13D831ec7',
    ],
    is_factory: true,
    sCurveRewards_abi: undefined,
    sCurveRewards_address: undefined,
    reward_token: undefined,
};

export {
    multicall_address,
    poolsData,
    factoryPoolDataSkeleton,
    Plain2Basic,
    Plain2BasicEMA,
    Plain2Balances,
    Plain2ETH,
    Plain2ETHEMA,
    Plain2Optimized,
    Plain3Basic,
    Plain3Balances,
    Plain3ETH,
    Plain3Optimized,
    Plain4Basic,
    Plain4Balances,
    Plain4ETH,
    Plain4Optimized,
};
